import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { CostEventsOfObjectMailApi } from "src/api/generated/erp/common/costEvents/api/costEventsOfObjectMailApi.ts";
import { CostEventObjectRef } from "src/api/generated/erp/common/costEvents/model/costEventObjectRef.ts";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { useFormInput } from "src/components/common/dialogs/formInput/useFormInput.tsx";
import { FormTextField } from "src/components/common/forms/fields/FormTextField.tsx";
import { emailRule, requireRule } from "src/components/common/forms/validation.ts";
import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";
import { useStoredState } from "src/utils/useStoredState.ts";

export interface SendCostEventsOfObjectByEmailButtonProps {
	objectRef: CostEventObjectRef;
}

interface FormValues {
	receiverEmail: string;
}

export const SendCostEventsOfObjectByEmailButton = ({ objectRef }: SendCostEventsOfObjectByEmailButtonProps) => {
	const showFormInput = useFormInput();
	const { userEmail } = useGlobalInitData();
	const [storedReceiverEmail, setStoredReceiverEmail] = useStoredState<string>({
		defaultValue: "",
		key: "6B8D40567F3A9E2C",
	});

	return (
		<AsyncButton
			icon={faEnvelope}
			label={i18n.t("send_cost_events_by_email")}
			variant={"menu"}
			onClick={onClick}
		/>
	);

	async function onClick() {
		const formValues = await showFormInput<FormValues>({
			title: i18n.t("send_cost_events_by_email"),
			submitLabel: i18n.t("send"),
			defaultValues: {
				receiverEmail: storedReceiverEmail || userEmail,
			},
			content: ({ control }) => (
				<FormTextField
					control={control}
					name={"receiverEmail"}
					label={i18n.t("receiver_mail")}
					rules={{
						...requireRule(),
						...emailRule(),
					}}
				/>
			),
		});
		if (formValues === undefined) return;

		setStoredReceiverEmail(formValues.receiverEmail);
		await CostEventsOfObjectMailApi.sendCostEventsOfObject({
			objectRef,
			receiverEmail: formValues.receiverEmail,
		});
	}
};
